import React, { useState, useEffect } from "react";
import { Users, X } from "@phosphor-icons/react";
import { useApp } from "@/context/AppContext";

// Persistent "Recommended: proceed with a parent" banner shown to anonymous
// users at the top of "Organizza la partenza" and "Profilo partenza".
// Dismissible: once closed, the choice is remembered in localStorage
// under the given storageKey so it doesn't come back on the same device.
export default function AnonBanner({ storageKey, testid = "anon-banner" }) {
  const { t } = useApp();
  const [dismissed, setDismissed] = useState(true); // start hidden to avoid flash

  useEffect(() => {
    try {
      setDismissed(localStorage.getItem(storageKey) === "1");
    } catch {
      setDismissed(false);
    }
  }, [storageKey]);

  const dismiss = () => {
    setDismissed(true);
    try { localStorage.setItem(storageKey, "1"); } catch { /* noop */ }
  };

  if (dismissed) return null;

  return (
    <div
      data-testid={testid}
      className="rounded-2xl border border-terracotta/30 bg-terracotta/5 px-4 py-3 flex items-start gap-3"
    >
      <div className="h-8 w-8 rounded-full bg-terracotta/10 flex items-center justify-center shrink-0 mt-0.5">
        <Users size={18} weight="duotone" className="text-terracotta" />
      </div>
      <p className="flex-1 text-sm text-ink font-sans font-semibold leading-relaxed">
        {t.common.anonBannerText}
      </p>
      <button
        type="button"
        aria-label={t.common.anonBannerDismiss}
        data-testid={`${testid}-dismiss`}
        onClick={dismiss}
        className="shrink-0 -mt-0.5 -mr-1 h-8 w-8 rounded-full flex items-center justify-center text-ink-soft hover:text-ink hover:bg-terracotta/10 transition-colors"
      >
        <X size={16} weight="bold" />
      </button>
    </div>
  );
}
